import { render } from "./ModelTyre.vue?vue&type=template&id=05dd9609&scoped=true"
import script from "./ModelTyre.vue?vue&type=script&lang=js"
export * from "./ModelTyre.vue?vue&type=script&lang=js"

import "./ModelTyre.vue?vue&type=style&index=0&id=05dd9609&lang=scss&scoped=true"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05dd9609"]])

export default __exports__